import React, { Component } from "react";
import {
  Button,
  Row,
  Col,
  Form,
  Card,
  Badge,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

import LoadingOverlay from "./LoadingOverlay";
export default class Dailystatusreport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),

      employeeList: [],
      holidaysList: [],
      attendanceData: {},
      tableData: [],

      selectedEmployees: [],
      dropdownOpen: false,
      employeeSearch: "",
      fromDate: new Date(),
      toDate: new Date(),
      reason: "",

      selectedRows: [],
      toggleCleared: false,
      filteredData: null,
      currentPage: 1,
      itemsPerPage: 20,
      loading: false,

      totalEmployees: 0,
      totalPresent: 0,
      totalAbsent: 0,
      totalOnLeave: 0,
      totalHolidays: 0,

      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => i + 1,
          sortable: false,
          width: "70px",
          cell: (row, i) => <span>{i + 1}</span>,
        },
        {
          name: "Employee Name",
          selector: (row) => row.employeeName,
          sortable: true,
          width: "180px",
          cell: (row) => <span>{row.employeeName}</span>,
        },
        {
          name: "Employee ID",
          selector: (row) => row.eId,
          sortable: true,
          width: "130px",
          cell: (row) => <span>{row.eId}</span>,
        },
        {
          name: "Date",
          selector: (row) => row.date,
          sortable: true,
          width: "120px",
          cell: (row) => <span>{row.displayDate}</span>,
        },
        {
          name: "Day",
          selector: (row) => row.dayName,
          sortable: true,
          width: "110px",
          cell: (row) => <span>{row.dayName}</span>,
        },
        {
          name: "Status",
          selector: (row) => row.status,
          sortable: true,
          width: "120px",
          cell: (row) => {
            let badgeBg = "secondary";
            if (row.status === "Present") badgeBg = "success";
            else if (row.status === "Absent") badgeBg = "danger";
            else if (row.status === "Leave") badgeBg = "warning";
            else if (row.status === "Holiday") badgeBg = "info";
            else if (row.status === "Sunday") badgeBg = "dark";
            return <Badge bg={badgeBg}>{row.status}</Badge>;
          },
        },
      ],
    };
  }

  componentDidMount() {
    this.EmployeesfetchHandler();
    this.HolidayslistfetchHandler();
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    if (
      this.dropdownRef &&
      !this.dropdownRef.contains(e.target) &&
      this.state.dropdownOpen
    ) {
      this.setState({ dropdownOpen: false });
    }
  };

  dropdownRef = null;

  // =================== API METHODS ===================

  EmployeesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Employees/listActive", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ employeeList: data.list });
        }
      })
      .catch((error) => {
        this.showToast("Failed to fetch employees", "error");
      });
  };

  HolidayslistfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Holidayslist/list", {
      method: "POST",
      mode: "cors",
      body: {},
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ holidaysList: data.list });
        }
      })
      .catch((error) => {
        this.showToast("Failed to fetch holidays", "error");
      });
  };

  AttendancefetchByEmployeeId = (employeeId) => {
    return new Promise((resolve, reject) => {
      var formData = new FormData();
      formData.append("sId", this.state.sId);
      formData.append("uId", this.state.uId);
      formData.append("employees_Id", employeeId);
      fetch(configData.api_url + "C_Employees/getattendancebyId", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "success") {
            resolve(data.list);
          } else {
            resolve({ leave: [], attended: [] });
          }
        })
        .catch((error) => {
          resolve({ leave: [], attended: [] });
        });
    });
  };

  fetchAttendanceForSelectedEmployees = () => {
    if (!this.validateSearch()) return;

    this.setState({ loading: true });

    const { selectedEmployees } = this.state;
    const promises = selectedEmployees.map((empId) =>
      this.AttendancefetchByEmployeeId(empId)
    );

    Promise.all(promises)
      .then((results) => {
        const attendanceData = {};
        selectedEmployees.forEach((empId, index) => {
          attendanceData[empId] = results[index];
        });
        this.setState({ attendanceData }, () => {
          this.processTableData();
        });
      })
      .catch((error) => {
        this.showToast("Error fetching attendance data", "error");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  rejectByEmployeeIds = () => {
    if (!this.validateReject()) return;

    const { selectedRows, reason } = this.state;
    const employeeIds = [
      ...new Set(selectedRows.map((row) => row.employees_Id)),
    ];
    const dates = selectedRows.map((row) => row.date);
    const fromDate = moment(this.state.fromDate).format("YYYY-MM-DD");
    const toDate = moment(this.state.toDate).format("YYYY-MM-DD");

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("employeeIds", JSON.stringify(employeeIds));
    formData.append("dates", JSON.stringify(dates));
    formData.append("fromDate", fromDate);
    formData.append("toDate", toDate);
    formData.append("reason", reason);

    fetch(configData.api_url + "C_Employees/recjectbyemployeeids", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState(
            {
              selectedRows: [],
              reason: "",
              toggleCleared: !this.state.toggleCleared,
            },
            () => {
              this.fetchAttendanceForSelectedEmployees();
            }
          );
        }
      })
      .catch((error) => {
        this.showToast("Error submitting rejection", "error");
      });
  };

  // =================== DATA PROCESSING ===================

  processTableData = () => {
    const {
      selectedEmployees,
      employeeList,
      attendanceData,
      holidaysList,
      fromDate,
      toDate,
    } = this.state;

    const from = moment(fromDate).startOf("day");
    const to = moment(toDate).startOf("day");
    const tableData = [];
    let totalPresent = 0;
    let totalAbsent = 0;
    let totalOnLeave = 0;
    let totalHolidays = 0;

    const holidayDatesSet = new Set(
      holidaysList.map((h) => moment(h.Date).format("YYYY-MM-DD"))
    );

    selectedEmployees.forEach((empId) => {
      const employee = employeeList.find(
        (e) => String(e.employees_Id) === String(empId)
      );
      if (!employee) return;

      const empAttendance = attendanceData[empId] || {
        leave: [],
        attended: [],
      };

      const attendedDatesSet = new Set(
        (empAttendance.attended || [])
          .filter((d) => d !== null)
          .map((d) => moment(d).format("YYYY-MM-DD"))
      );

      const leaveDatesSet = new Set(
        (empAttendance.leave || [])
          .filter((d) => d !== null)
          .map((d) => moment(d).format("YYYY-MM-DD"))
      );

      let current = moment(from);
      while (current.isSameOrBefore(to)) {
        const dateStr = current.format("YYYY-MM-DD");
        const dayOfWeek = current.day();
        let status = "Absent";

        if (dayOfWeek === 0) {
          status = "Sunday";
        } else if (holidayDatesSet.has(dateStr)) {
          status = "Holiday";
          totalHolidays++;
        } else if (attendedDatesSet.has(dateStr)) {
          status = "Present";
          totalPresent++;
        } else if (leaveDatesSet.has(dateStr)) {
          status = "Leave";
          totalOnLeave++;
        } else {
          if (current.isSameOrBefore(moment(), "day")) {
            status = "Absent";
            totalAbsent++;
          } else {
            status = "Upcoming";
          }
        }

        tableData.push({
          id: `${empId}_${dateStr}`,
          employees_Id: empId,
          employeeName: `${employee.fName} ${employee.lName}`,
          eId: employee.eId,
          date: dateStr,
          displayDate: moment(dateStr).format("DD/MM/YYYY"),
          dayName: current.format("dddd"),
          status: status,
        });

        current.add(1, "day");
      }
    });

    // Auto-select today's absent rows
    const today = moment().format("YYYY-MM-DD");
    const todayAbsentRows = tableData.filter(
      (row) => row.date === today && row.status === "Absent"
    );

    this.setState({
      tableData,
      filteredData: null,
      selectedRows: todayAbsentRows,
      totalEmployees: selectedEmployees.length,
      totalPresent,
      totalAbsent,
      totalOnLeave,
      totalHolidays,
    });
  };

  // =================== VALIDATION ===================

  validateSearch = () => {
    const { selectedEmployees, fromDate, toDate } = this.state;
    if (selectedEmployees.length === 0) {
      this.showToast("Please select at least one employee", "error");
      return false;
    }
    if (!fromDate) {
      this.showToast("From Date is mandatory", "error");
      return false;
    }
    if (!toDate) {
      this.showToast("To Date is mandatory", "error");
      return false;
    }
    if (moment(fromDate).isAfter(moment(toDate))) {
      this.showToast("From Date cannot be after To Date", "error");
      return false;
    }
    return true;
  };

  validateReject = () => {
    const { selectedRows, reason } = this.state;
    if (selectedRows.length === 0) {
      this.showToast("Please select at least one row to reject", "error");
      return false;
    }
    if (!reason || reason.trim() === "") {
      this.showToast("Reason is mandatory", "error");
      return false;
    }
    return true;
  };

  // =================== EVENT HANDLERS ===================

  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };

  handleEmployeeToggle = (empId) => {
    this.setState((prevState) => {
      const selected = prevState.selectedEmployees.includes(empId)
        ? prevState.selectedEmployees.filter((id) => id !== empId)
        : [...prevState.selectedEmployees, empId];
      return { selectedEmployees: selected };
    });
  };

  handleSelectAllEmployees = () => {
    const filtered = this.getFilteredEmployees();
    const allFilteredIds = filtered.map((emp) => String(emp.employees_Id));
    const allSelected = allFilteredIds.every((id) =>
      this.state.selectedEmployees.includes(id)
    );
    if (allSelected) {
      this.setState({ selectedEmployees: [] });
    } else {
      this.setState({ selectedEmployees: allFilteredIds });
    }
  };

  getFilteredEmployees = () => {
    const { employeeList, employeeSearch } = this.state;
    if (!employeeSearch) return employeeList;
    const search = employeeSearch.toLowerCase();
    return employeeList.filter(
      (emp) =>
        `${emp.fName} ${emp.lName}`.toLowerCase().includes(search) ||
        (emp.eId && emp.eId.toLowerCase().includes(search))
    );
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({ dropdownOpen: !prevState.dropdownOpen }));
  };

  handleFromDateChange = (date) => {
    this.setState({ fromDate: date });
  };

  handleToDateChange = (date) => {
    this.setState({ toDate: date });
  };

  handleReasonChange = (e) => {
    this.setState({ reason: e.target.value });
  };

  handleSelectedRowsChange = ({ selectedRows }) => {
    this.setState({ selectedRows });
  };

  handleApplyAll = () => {
    const allRows = this.state.filteredData || this.state.tableData;
    const selectableRows = allRows.filter(
      (row) =>
        row.status !== "Present" &&
        row.status !== "Holiday" &&
        row.status !== "Sunday" &&
        row.status !== "Upcoming"
    );
    this.setState({ selectedRows: selectableRows });
    this.showToast(`Selected ${selectableRows.length} rows`, "info");
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    if (!searchValue) {
      this.setState({ filteredData: null });
      return;
    }
    const filteredData = this.state.tableData.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  handleSearchClick = () => {
    this.fetchAttendanceForSelectedEmployees();
  };

  handleRejectClick = () => {
    this.rejectByEmployeeIds();
  };

  // =================== RENDER ===================

  render() {
    const displayData = this.state.filteredData || this.state.tableData;

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        {/* Header */}
        <Row className="mb-3">
          <Col md="6">
            <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>
              Daily Status Report
            </h3>
          </Col>
          <Col md="6" className="text-end">
            <h5 style={{ paddingTop: "8px" }}>
              {moment().format("DD/MM/YYYY")} - {moment().format("dddd")}
            </h5>
          </Col>
        </Row>

        {/* Filter Section */}
        <Card className="mb-3">
          <Card.Body>
            <Row>
              {/* Employee Multi-Select Dropdown */}
              <Col md="4">
                <Form.Group>
                  <Form.Label>
                    Select Employee(s) <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <div
                    style={{ position: "relative" }}
                    ref={(ref) => (this.dropdownRef = ref)}
                  >
                    <div
                      className="form-control"
                      onClick={this.toggleDropdown}
                      style={{
                        cursor: "pointer",
                        minHeight: "38px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <span
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {this.state.selectedEmployees.length > 0
                          ? `${this.state.selectedEmployees.length} employee(s) selected`
                          : "Select Employee(s)"}
                      </span>
                      <i
                        className={`bi bi-chevron-${
                          this.state.dropdownOpen ? "up" : "down"
                        }`}
                      ></i>
                    </div>

                    {this.state.dropdownOpen && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                          zIndex: 1000,
                          backgroundColor: "#fff",
                          border: "1px solid #ced4da",
                          borderRadius: "0 0 4px 4px",
                          maxHeight: "250px",
                          overflowY: "auto",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                        }}
                      >
                        {/* Search */}
                        <div style={{ padding: "6px 10px", borderBottom: "1px solid #eee" }}>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search employees..."
                            value={this.state.employeeSearch}
                            onChange={(e) =>
                              this.setState({ employeeSearch: e.target.value })
                            }
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>

                        {/* Select All */}
                        <div
                          style={{
                            padding: "6px 10px",
                            borderBottom: "1px solid #eee",
                            backgroundColor: "#f8f9fa",
                          }}
                        >
                          <Form.Check
                            type="checkbox"
                            label={
                              <strong>
                                Select All ({this.getFilteredEmployees().length})
                              </strong>
                            }
                            checked={
                              this.getFilteredEmployees().length > 0 &&
                              this.getFilteredEmployees().every((emp) =>
                                this.state.selectedEmployees.includes(
                                  String(emp.employees_Id)
                                )
                              )
                            }
                            onChange={this.handleSelectAllEmployees}
                          />
                        </div>

                        {/* Employee List */}
                        {this.getFilteredEmployees().map((emp, index) => (
                          <div
                            key={index}
                            style={{
                              padding: "4px 10px",
                              borderBottom: "1px solid #f0f0f0",
                            }}
                          >
                            <Form.Check
                              type="checkbox"
                              label={`${emp.fName} ${emp.lName} - ${emp.eId}`}
                              checked={this.state.selectedEmployees.includes(
                                String(emp.employees_Id)
                              )}
                              onChange={() =>
                                this.handleEmployeeToggle(
                                  String(emp.employees_Id)
                                )
                              }
                            />
                          </div>
                        ))}

                        {this.getFilteredEmployees().length === 0 && (
                          <div
                            style={{
                              padding: "10px",
                              textAlign: "center",
                              color: "#999",
                            }}
                          >
                            No employees found
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </Form.Group>
              </Col>

              {/* From Date */}
              <Col md="3">
                <Form.Group>
                  <Form.Label>
                    From Date <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <DatePicker
                    selected={this.state.fromDate}
                    onChange={this.handleFromDateChange}
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                    maxDate={new Date()}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </Form.Group>
              </Col>

              {/* To Date */}
              <Col md="3">
                <Form.Group>
                  <Form.Label>
                    To Date <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <DatePicker
                    selected={this.state.toDate}
                    onChange={this.handleToDateChange}
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                    maxDate={new Date()}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </Form.Group>
              </Col>

              {/* Search Button */}
              <Col md="2" className="d-flex align-items-end">
                <Button
                  variant="primary"
                  className="w-100"
                  onClick={this.handleSearchClick}
                  disabled={this.state.loading}
                >
                  {this.state.loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-1"
                        role="status"
                      ></span>
                      Loading...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-search me-1"></i> Fetch Report
                    </>
                  )}
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Summary Badges */}
        {/* {this.state.tableData.length > 0 && (
          <Row className="mb-3 text-center">
            <Col>
              <Badge
                bg="primary"
                className="p-2 mx-1"
                style={{ fontSize: "14px" }}
              >
                Total Employees: {this.state.totalEmployees}
              </Badge>
              <Badge
                bg="success"
                className="p-2 mx-1"
                style={{ fontSize: "14px" }}
              >
                Present: {this.state.totalPresent}
              </Badge>
              <Badge
                bg="danger"
                className="p-2 mx-1"
                style={{ fontSize: "14px" }}
              >
                Absent: {this.state.totalAbsent}
              </Badge>
              <Badge
                bg="warning"
                className="p-2 mx-1"
                style={{ fontSize: "14px" }}
              >
                On Leave: {this.state.totalOnLeave}
              </Badge>
              <Badge
                bg="info"
                className="p-2 mx-1"
                style={{ fontSize: "14px" }}
              >
                Holidays: {this.state.totalHolidays}
              </Badge>
            </Col>
          </Row>
        )} */}

        {/* DataTable Section */}
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <Row className="mb-2">
                  <Col md="4">
                    <input
                      type="text"
                      onChange={this.handleFilter}
                      placeholder="Search..."
                      className="form-control"
                    />
                  </Col>
                  <Col md="8" className="text-end">
                    {this.state.tableData.length > 0 && (
                      <Button
                        variant="outline-primary"
                        onClick={this.handleApplyAll}
                      >
                        <i className="bi bi-check2-all me-1"></i> Apply All
                      </Button>
                    )}
                  </Col>
                </Row>

                <DataTable
                  columns={this.state.tableClms}
                  data={displayData}
                  selectableRows
                  onSelectedRowsChange={this.handleSelectedRowsChange}
                  clearSelectedRows={this.state.toggleCleared}
                  selectableRowDisabled={(row) =>
                    row.status === "Present" ||
                    row.status === "Holiday" ||
                    row.status === "Sunday" ||
                    row.status === "Upcoming"
                  }
                  selectableRowSelected={(row) =>
                    this.state.selectedRows.some((sr) => sr.id === row.id)
                  }
                  pagination
                  paginationPerPage={20}
                  paginationRowsPerPageOptions={[10, 20, 50, 100]}
                  highlightOnHover
                  responsive
                  striped
                  noDataComponent={
                    <div className="text-center p-4">
                      No attendance data found. Please select employees and
                      date range.
                    </div>
                  }
                  className="table table-striped table-bordered dataTable no-footer"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Action Section */}
        {this.state.tableData.length > 0 && (
          <Card className="mt-3">
            <Card.Body>
              <Row>
                <Col md="8">
                  <Form.Group>
                    <Form.Label>
                      Reason <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="reason"
                      value={this.state.reason}
                      onChange={this.handleReasonChange}
                      placeholder="Enter reason for rejection (mandatory)"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md="4" className="d-flex align-items-end">
                  <Button
                    variant="danger"
                    className="w-100"
                    onClick={this.handleRejectClick}
                    disabled={
                      this.state.selectedRows.length === 0 || !this.state.reason
                    }
                  >
                    <i className="bi bi-x-circle me-1"></i> Reject Selected (
                    {this.state.selectedRows.length})
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        )}
      </div>
    );
  }
}
